// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../utils/colors.css\"","red":"#A93E2F","redUnderline":"Input_redUnderline__303qe","invalid":"Input_invalid__1e2qC"};